/**
 * Storage Utilities
 *
 * Utilities for working with localStorage and sessionStorage
 */

import { decryptObject, encryptObject } from './cryptoUtils';

/**
 * Get item from localStorage
 */
export const getCache = (key: string): string | null => {
  return localStorage.getItem(key);
};

/**
 * Set item in localStorage
 */
export const setCache = (key: string, value: string): void => {
  localStorage.setItem(key, value);
};

/**
 * Remove item from localStorage
 */
export const clearCache = (key: string): void => {
  localStorage.removeItem(key);
};

/**
 * Get encrypted user data from localStorage
 */
export const getUserEncrypted = (): Record<string, any> => {
  const userData = getCache('USER');
  if (!userData) return {};
  return decryptObject(userData);
};

/**
 * Set encrypted user data in localStorage
 */
export const setUserEncrypted = (user: Record<string, any>): void => {
  const encryptedUser = encryptObject(user);
  setCache('USER', encryptedUser);
};
